export default __webpack_public_path__ + "static/media/arrow-left.d936fa1e.svg";